import { useEffect, useState } from "react";
import { getLatestWidget, type WidgetLatest } from "@/lib/api";
import { DownloadDesktopApp } from "@/components/DownloadDesktopApp";

/**
 * /download — landing page for the welcome email's "Carmen downloaden"
 * button and the native apps' desktop-setup link. It intentionally contains
 * installers only: no registration, pricing, billing, or purchase flow.
 */
export function DownloadPage() {
  const [manifest, setManifest] = useState<WidgetLatest | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;
    getLatestWidget()
      .then((data) => {
        if (active) setManifest(data);
      })
      .catch(() => {
        /* manifest not published yet */
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="mx-auto w-full max-w-2xl space-y-6 px-4 py-8">
      <div>
        <h1 className="text-[28px] font-semibold tracking-[-0.03em] text-[var(--cs-navy)]">
          Carmen downloaden
        </h1>
        <p className="mt-1 text-[15px] text-[rgba(95,131,160,0.96)]">
          Installeer de Carmen-app voor Windows of macOS.
        </p>
      </div>
      <DownloadDesktopApp manifest={manifest} />
      {!isLoading && !manifest && (
        <div className="text-sm text-[#536274]">
          Geen desktop-download beschikbaar? Neem contact op via support@askcarmen.eu.
        </div>
      )}
    </div>
  );
}
